module.exports = __webpack_public_path__ + "img/register.43ad0cb4.svg";